import axios from "axios";

export const fetchGetAllCompanies = async () => {
  return await axios.get("/api/company?pageSize=-1");
};
